import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ForYou() {
  const { t } = useTranslation();

  const yesItems = [
    t('phoenix.yes1'),
    t('phoenix.yes2'),
    t('phoenix.yes3'),
    t('phoenix.yes4'),
    t('phoenix.yes5'),
  ];

  const noItems = [
    t('phoenix.no1'),
    t('phoenix.no2'),
    t('phoenix.no3'),
  ];

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1100px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200/50 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.forYouTag')}
          </span>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 mt-12">
          <ScrollReveal direction="left" delay={0.1}>
            <div className="rounded-3xl bg-white border border-background-200/70 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-8 md:p-10 h-full">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 rounded-xl bg-green-100 flex items-center justify-center">
                  <i className="ri-check-line text-green-600 text-xl"></i>
                </span>
                {t('phoenix.yesTitle')}
              </h3>
              <ul className="space-y-4">
                {yesItems.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-green-500 text-lg mt-0.5 shrink-0"></i>
                    <span className="text-foreground-700 text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" delay={0.2}>
            <div className="rounded-3xl bg-white border border-background-200/70 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-8 md:p-10 h-full">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center">
                  <i className="ri-close-line text-red-500 text-xl"></i>
                </span>
                {t('phoenix.noTitle')}
              </h3>
              <ul className="space-y-4">
                {noItems.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-red-400 text-lg mt-0.5 shrink-0"></i>
                    <span className="text-foreground-500 text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}